<a *ngIf="videoControls.ready$ | async" [href]="videoUrl" download>
  <studio-button-legacy [isIconOnly]="true" theme="dark-tertiary">
    <studio-icon name="download"></studio-icon>
  </studio-button-legacy>
</a>
